import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { selectSettingStyle } from 'src/app/stores/settings/settings.selector';

import { StyleSettings } from '../appconfig/settings.model';

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  constructor(@Inject(DOCUMENT) private document: Document, private store: Store) {}

  initTheme(): void {
    this.store.select(selectSettingStyle).subscribe((style: StyleSettings) => {
      this.applyTheme(style);
    });
  }

  private applyTheme(style: StyleSettings): void {
    const root = this.document.documentElement;
    root.style.setProperty('--primary-color', style.primaryColor);
    root.style.setProperty('--accent-color', style.thirdColor);
    root.style.setProperty('--success-color', '#b0bc22');
    root.style.setProperty('--error-color', '#ad0000');
    root.style.setProperty('--white-color', '#ffffff');
  }
}
